import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  projectsListContainer: {
    marginBottom: theme.spacing(1)
  },
  methodology: {
    whiteSpace: 'pre-line',
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal'
    }
  },
  containerGridSuperior: {
    marginTop: theme.spacing(3),
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  gridContainer: {
    width: 'auto',
    borderRadius: '30px',
    justifyContent: 'center',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    margin: 0
  },
  gridContainerTechnologies: {
    width: '500px',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
      gridDirection: 'column'
    }
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px'
  },
  gridItemText: {
    fontWeight: 500
  },
  icon: {
    width: '55px',
    height: '55px',
    [theme.breakpoints.down('sm')]: {
      width: '46px',
      height: '46px'
    }
  },
  iconText: {
    flexGrow: 1,
    fontWeight: 500
  },
  technologiesTextIcon: {
    width: '50px',
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      width: 'auto',
      flexGrow: 1
    }
  }
}))
